<template>
  <div class="d-flex align-items-center min-vh-100">
    <b-container>
      <b-row class="justify-content-center">
        <h1 class="float-left display-3 mr-4">500</h1>
        <div>
          <h4 class="pt-3">{{$t('page500_view.title')}}</h4>
          <p class="text-muted" v-t="$t('page500_view.content')" />
        </div>
        <b-button class="mt-4" block variant="primary" to="/">
          {{$t('page_title.home')}}
        </b-button>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'Page500',
  created() {
    window.document.title = 'Error 500'
  }
}
</script>
